export default __webpack_public_path__ + "img/bg-91f6ac4f.png";